import { NASELJA } from '../lib/konstante';
import { FILTRI } from '../lib/evidencija';
import Ikona from './Ikona';
import StatusTocke from './StatusTocke';

export default function PopisEvidencije({
  zapisi,
  sviZapisi,
  novo,
  odabraniId,
  naOdabir,
  uvjeti,
  naUvjete,
  naKartu,
  sazet = false,
}) {
  const filtri = novo ? FILTRI : FILTRI.filter((f) => f.kljuc !== 'nejasno');
  return (
    <section
      className={`evidencija ${sazet ? 'evidencija-sazeta' : ''}`}
      aria-label={novo ? 'Popis kućanstava' : 'Stari popis članova'}
    >
      <div className="traka-pretrage">
        <label className="polje-trazenja">
          <Ikona naziv="trazi" velicina={18} />
          <input
            type="search"
            aria-label="Pretraži evidenciju"
            placeholder={
              novo
                ? 'Traži adresu ili nositelja…'
                : 'Traži ime, adresu ili redni broj…'
            }
            value={uvjeti.upit}
            onChange={(e) => naUvjete({ ...uvjeti, upit: e.target.value })}
          />
        </label>
        <label className="odabir-naselja">
          <span className="samo-citac">Naselje</span>
          <select
            value={uvjeti.naselje}
            onChange={(e) => naUvjete({ ...uvjeti, naselje: e.target.value })}
          >
            <option value="">Sva naselja</option>
            {NASELJA.map((n) => (
              <option key={n.naziv}>{n.naziv}</option>
            ))}
            {!novo && <option value="bez">Bez naselja</option>}
          </select>
        </label>
      </div>
      <div className="filteri" aria-label="Filtriraj prema statusu">
        {filtri.map((f) => (
          <button
            key={f.kljuc}
            type="button"
            aria-pressed={uvjeti.filter === f.kljuc}
            onClick={() => naUvjete({ ...uvjeti, filter: f.kljuc })}
          >
            {f.naziv}
            <span>{sviZapisi.filter(f.test).length}</span>
          </button>
        ))}
      </div>
      <div className="zaglavlje-popisa">
        <span>
          {zapisi.length} od {sviZapisi.length}{' '}
          {novo ? 'kućanstava' : 'članova'}
        </span>
        <span>{novo ? 'Po adresi' : 'Po rednom broju'}</span>
      </div>
      <div className="popis" role="list">
        {!sazet && (
          <div className="stupci-popisa" aria-hidden="true">
            <span>{novo ? 'Adresa i nositelj' : 'Član i adresa'}</span>
            <span>Naselje</span>
            <span>Status pozicije</span>
            <span />
          </div>
        )}
        {zapisi.length === 0 ? (
          <div className="prazno">
            <Ikona naziv="trazi" velicina={30} />
            <h3>Nema rezultata</h3>
            <p>Pokušaj promijeniti pretragu ili odabrane filtre.</p>
            <button
              className="gumb sek"
              onClick={() => naUvjete({ upit: '', naselje: '', filter: 'svi' })}
            >
              Očisti filtre
            </button>
          </div>
        ) : (
          zapisi.map((z) => (
            <div role="listitem" key={z.id}>
              <button
                type="button"
                className={`stavka ${odabraniId === z.id ? 'odabrana' : ''}`}
                aria-pressed={odabraniId === z.id}
                onClick={() => naOdabir(z.id)}
              >
                <span
                  className={`avatar-zapisa ${z.stanje === 'nejasno' ? 'upozorenje' : ''}`}
                >
                  {novo ? (
                    <Ikona naziv="kuca" />
                  ) : z.redni_broj != null ? (
                    String(z.redni_broj).padStart(2, '0')
                  ) : (
                    '—'
                  )}
                </span>
                <span className="tijelo-stavke">
                  <strong>{novo ? z.adresa : `${z.prezime} ${z.ime}`}</strong>
                  <span>
                    {novo
                      ? `${z.nositelj_prezime} ${z.nositelj_ime}`
                      : z.adresa || 'Adresa nije upisana'}
                    {novo && z.broj_prikljucaka > 1 && (
                      <em> · {z.broj_prikljucaka} priključka</em>
                    )}
                  </span>
                  {z.stanje === 'nejasno' && (
                    <small className="tekst-upozorenja">
                      Podaci za provjeru
                    </small>
                  )}
                </span>
                {!sazet && (
                  <span className="naselje-stavke">{z.naselje || '—'}</span>
                )}
                <StatusTocke status={z.status} />
                <Ikona naziv="desno" velicina={16} />
              </button>
            </div>
          ))
        )}
      </div>
      {sazet && (
        <div className="podnozje-popisa">
          <Ikona naziv="info" velicina={15} />
          <span>Odaberi zapis za detalje i poziciju.</span>
        </div>
      )}
      {!sazet && (
        <div className="podnozje-popisa">
          <span>
            Prikazani su podaci iz{' '}
            {novo ? 'nove evidencije kućanstava' : 'izvorne bilježnice'}.
          </span>
          <button className="tekst-gumb" onClick={naKartu}>
            Prikaži na karti <Ikona naziv="strelica" velicina={16} />
          </button>
        </div>
      )}
    </section>
  );
}
